import { css } from '@emotion/css';
import { Spacing } from '@snapchat/snap-design-system';

export const tenantsSectionClassName = css({
  paddingTop: Spacing.MD,
});
